<template>
    <div class="gofixSplit">
        <div class="splitItem splitLeft">
            <slot name="gofixSplit:left"></slot>
        </div>
        <div class="splitControl"></div>
        <div class="splitItem splitRight">
            <slot name="gofixSplit:right"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "gofix-split",
        props: {
            min: {
                type: [Number],
                required: false,
                default: () => 0
            },
        },
        data() {
            return {

            }
        },
        created(){

        },
        methods: {

        }
    }
</script>

